import React, { useState } from 'react';
import { FileUploader } from '../common/FileUploader';
export function UploadDocuments() {
  const [selectedCategory, setSelectedCategory] = useState('Director Data');
  const categories = ['Director Data', 'Company Info', 'Carrier agreements', 'Other'];
  return <div className="bg-white rounded-lg shadow" data-id="element-528">
      <div className="p-6" data-id="element-529">
        <h2 className="text-xl font-semibold mb-6" data-id="element-530">
          Upload Supporting Documents
        </h2>
        <div className="grid md:grid-cols-2 gap-6" data-id="element-531">
          <div className="bg-gray-50 p-6 rounded-lg border border-gray-200" data-id="element-532">
            <h3 className="font-medium text-lg mb-4" data-id="element-533">Document Upload</h3>
            <div className="mb-4" data-id="element-534">
              <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-535">
                Document Category
              </label>
              <select value={selectedCategory} onChange={e => setSelectedCategory(e.target.value)} className="w-full p-2 border rounded-md" data-id="element-536">
                {categories.map(category => <option key={category} value={category} data-id="element-537">
                    {category}
                  </option>)}
              </select>
            </div>
            <FileUploader data-id="element-538" />
            <div className="mt-6 text-sm text-gray-500" data-id="element-539">
              <p data-id="element-540">Acceptable document formats: PDF, DOC, DOCX, XLS, XLSX</p>
              <p data-id="element-541">Maximum file size: 10MB</p>
            </div>
          </div>
          <div className="bg-gray-50 p-6 rounded-lg border border-gray-200" data-id="element-542">
            <h3 className="font-medium text-lg mb-4" data-id="element-543">Document Requirements</h3>
            <div className="space-y-4" data-id="element-544">
              <div data-id="element-545">
                <h4 className="font-medium" data-id="element-546">Director Data</h4>
                <p className="text-sm text-gray-600" data-id="element-547">
                  Personal information for all company directors including ID
                  verification documents.
                </p>
              </div>
              <div data-id="element-548">
                <h4 className="font-medium" data-id="element-549">Company Info</h4>
                <p className="text-sm text-gray-600" data-id="element-550">
                  Company registration documents, business address proof, and
                  corporate structure.
                </p>
              </div>
              <div data-id="element-551">
                <h4 className="font-medium" data-id="element-552">Carrier agreements</h4>
                <p className="text-sm text-gray-600" data-id="element-553">
                  All existing carrier and capacity provider agreements.
                </p>
              </div>
              <div data-id="element-554">
                <h4 className="font-medium" data-id="element-555">Other</h4>
                <p className="text-sm text-gray-600" data-id="element-556">
                  Any other supporting documentation relevant to your
                  application.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}